import { Link } from 'react-router-dom';
import { useQuery } from '@tanstack/react-query';
import { formatPriceCents } from '@gobingebox/shared';
import { posterGradient } from '@/lib/posters';
import { EmptyState, PageHero } from '@/components/PagePlaceholder';
import { NotifyForm } from '@/components/NotifyForm';
import { ShoppingBag } from '@/components/icons';
import { catalogApi } from '@/features/catalog/api';

export function StorePage() {
  const { data, isLoading } = useQuery({ queryKey: ['store'], queryFn: catalogApi.storeProducts });
  const products = data?.products ?? [];

  return (
    <div>
      <PageHero
        eyebrow="Store"
        title="Official merch, open to everyone."
        subtitle="No subscription required to shop. Subscribers get their tier's discount automatically at checkout."
      />
      <div className="container-page pb-16">
        {isLoading ? (
          <p className="text-sm text-ink-faint">Loading…</p>
        ) : products.length === 0 ? (
          <EmptyState
            icon={<ShoppingBag size={26} strokeWidth={1.75} />}
            title="There's nothing here yet"
            description="The shelves are being stocked. Leave your email and we'll tell you when the first products drop."
            action={<NotifyForm topic="store" />}
          />
        ) : (
          <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-4">
            {products.map((p) => (
              <Link key={p.id} to={`/store/${p.slug}`} className="card overflow-hidden transition-transform hover:scale-[1.01]">
                <div
                  className="aspect-square w-full"
                  style={p.images[0] ? { backgroundImage: `url(${p.images[0]})`, backgroundSize: 'cover' } : { backgroundImage: posterGradient(p.id) }}
                />
                <div className="p-4">
                  <p className="truncate font-medium text-ink">{p.name}</p>
                  <p className="mt-1 text-sm text-brand-soft">{formatPriceCents(p.priceCents)}</p>
                </div>
              </Link>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
